import sales from './sales/routes';
import product from './product/routes';
import service from './service/routes';
import shift from './shift/routes';
import cash from './cash/routes';
import labor from './labor/routes';
import people from './people/routes';
import foodAndInventory from './foodAndInventory/routes';
import budget from './budget/routes';
import calendar from './calendar/routes';
import { multiClientMenuFilters } from './mtEnterprises';

const routes = [
  {
    path: '/',
    alias: '/home-dashboard',
    name: 'Home',
    nameES: 'Inicio',
    meta: { hidePageHeader: true },
    icon: 'mdi-home',
    v3: true,
    component: () => import('./Dashboard.vue'),
    menuFilters: multiClientMenuFilters,
  },
  sales,
  product,
  service,
  shift,
  cash,
  labor,
  people,
  foodAndInventory,
  budget,
  calendar,
];

export default routes;
